export default {

    getFormRecordAll: function(form) {
        var record={};
        form.forEach(function(section) {
            section.fields.forEach(function(f) {
                record[f.name]=f.value;
            });
        });
        return record;
    },
    getFormRecord: function(form, dati) {
        var setFieldValue=function(obj, path, val) {
            // eslint-disable-next-line no-redeclare
            path=path.split('.');
            var len=path.length;
            var objptr=obj;
            for (var i=0; i<len-1; i++){
                obj[path[i]]={};
                objptr=obj[path[i]];
            }
            objptr[path[len-1]]=val;
            return obj;
        }
    
        var o={};
        console.log('getFormRecord')
        for (var f in dati) {
            // console.log(f);
//            if (dati[f]) { // null will blank the field
                form.forEach(function(section) {
                    var field=section.fields.find(function(e,i) {
                        if (e.name==f && !e.disabled) return true;
                        return false;
                    })
                    if (field) {
                        setFieldValue(o, field.name, dati[field.name])                        
                    }               
                })
//            }
        }
        return o;
    },

    tabs: [
        { "order": 1, "name": "Home", "component": "Home", "path": "/" },
        { "order": 2, "name": "Prodotti", "component": "Prodotti", "path": "/prodotti"  },
        { "order": 3, "name": "Linee", "component": "Linee", "path": "/linee"  },
        { "order": 4, "name": "Help", "component": "Help", "path": "/help"  },
    ],

    /*
    leads: { 
        table: function () {
            var ord=1;
            var cols=[];

            cols.push( { order: ord++, value:'', label:'Ragione Sociale', name:'Company', type:'truncate' } );
            cols.push( { order: ord++, value:'', label:'Insegna', name:'Insegna__c', type:'truncate' } );
            cols.push( { order: ord++, value:'', label:'Tipo', name:'Industry', type:'truncate' } );
            cols.push( { order: ord++, value:'', label:'Stato', name:'Status', type:'truncate' } );
        
            cols.push( { order: ord++, value:'', label:'Email', name:'Email', type:'string' } );
            cols.push( { order: ord++, value:'', label:'Telefono', name:'Phone', type:'string' } );
            cols.push( { order: ord++, value:'', label:'Web', name:'Website', type:'string' } );

            cols.push( { order: ord++, value:'', label:'Indirizzo', name:'Street', type:'string' } );
            cols.push( { order: ord++, value:'', label:'Città', name:'City', type:'string' } );
            cols.push( { order: ord++, value:'', label:'Cap', name:'PostalCode', type:'string' } );
            cols.push( { order: ord++, value:'', label:'Provincia', name:'State', type:'string' } );
            cols.push( { order: ord++, value:'', label:'Note', name:'Description', type:'string' } );

            return cols;
        },
        form: function (dati) {
            var itab=0;
            var sectionFields=[];
            var sections=[];
            sectionFields.push( { id:itab++, value: (dati?dati.Company:dati), title:'Ragione Sociale', name:'Company', type:'text', placeholder:'Ragione Sociale', tabindex:itab++, disabled: false} );
            sectionFields.push( { id:itab++, value: (dati?dati.Insegna__c:dati), title:'Insegna', name:'Insegna__c', type:'text', placeholder:'Insegna', tabindex:itab++, disabled: false} );
            sectionFields.push( { id:itab++, value: (dati?dati.Insegna__c:dati), title:'P.Iva', name:'P_Iva__c', type:'text', placeholder:'P.Iva', tabindex:itab++, disabled: false} );
            sections.push( { order: 1, title: 'Dati principali', opened: true, fields: sectionFields  });
            sectionFields=[];
            sectionFields.push( { id:itab++, value: (dati?dati.Industry:dati), title:'Tipo', name:'Industry', type:'picklist', 
                options:[ 
                    {label:'ALBERGHI, PENSIONI, AGRITURISM', value:'ALBERGHI, PENSIONI, AGRITURISM'},
                    {label:'ALIMENTARI, DROGHERIE', value:'ALIMENTARI, DROGHERIE'},
                    {label:'AZIENDE/NS.FORNITORI (PERSONE', value:'AZIENDE/NS.FORNITORI (PERSONE'},
                    {label:'BOTTIGLIERIE, ENOTECHE', value:'BOTTIGLIERIE, ENOTECHE'},
                    {label:'E-COMMERCE', value:'E-COMMERCE'},
                    {label:'ENOTECA/DISTRIBUTORE', value:'ENOTECA/DISTRIBUTORE'},
                    {label:'GROSSISTI TRADIZIONALI', value:'GROSSISTI TRADIZIONALI'},
                    {label:'PRIVATI (PERSONE FISICHE)', value:'PRIVATI (PERSONE FISICHE)'},
                    {label:'RIST.TRATT.OSTER.PIZZ.TAVOLE C', value:'RIST.TRATT.OSTER.PIZZ.TAVOLE C'},
                    {label:'WINE-BAR, BAR, PASTICCERIE', value:'WINE-BAR, BAR, PASTICCERIE'},
                    ], placeholder:'Tipo', tabindex:itab++, disabled: false} );
        
            sectionFields.push( { id:itab++, value: (dati?dati.Description:dati), title:'Note', name:'Description', type:'textarea', placeholder:'Note', tabindex:itab++, disabled: false} );
            sections.push( { order: 4, title: 'Dati qualitativi', opened: true, fields: sectionFields  });
            sectionFields=[];
            sectionFields.push( { id:itab++, value: (dati?dati.Street:dati), title:'Autocomplete', name:'Autocomplete', type:'gmapaddress', placeholder:'ricerca indirizzi...', tabindex:itab++, disabled: false} );
            sectionFields.push( { id:itab++, value: (dati?dati.Street:dati), title:'Indirizzo', name:'Street', type:'text', placeholder:'Indirizzo', tabindex:itab++, disabled: false} );
            sectionFields.push( { id:itab++, value: (dati?dati.City:dati), title:'Città', name:'City', type:'text', placeholder:'Città', tabindex:itab++, disabled: false} );
            sectionFields.push( { id:itab++, value: (dati?dati.PostalCode:dati), title:'Cap', name:'PostalCode', type:'text', placeholder:'Cap', tabindex:itab++, disabled: false} );
            sectionFields.push( { id:itab++, value: (dati?dati.State:dati), title:'Provincia', name:'State', type:'text', placeholder:'Provincia', tabindex:itab++, disabled: false} );
            sectionFields.push( { id:itab++, value: (dati?dati.Country:dati), title:'Nazione', name:'Country', type:'text', placeholder:'Nazione', tabindex:itab++, disabled: false} );
            sections.push( { order: 2, title: 'Sede Legale', opened: true, fields: sectionFields  });
            sectionFields=[];
            sectionFields.push( { id:itab++, value: (dati?dati.Email_Distributore__c:dati), title:'Email', name:'Email', type:'text', placeholder:'Email', tabindex:itab++, disabled: false} );
            sectionFields.push( { id:itab++, value: (dati?dati.Phone:dati), title:'Telefono', name:'Phone', type:'text', placeholder:'Telefono', tabindex:itab++, disabled: false} );
            sectionFields.push( { id:itab++, value: (dati?dati.Website:dati), title:'Web', name:'Website', type:'text', placeholder:'Web', tabindex:itab++, disabled: false} );
            sections.push( { order: 3, title: 'Contatto', opened: true, fields: sectionFields  });

            return sections;
        }
    },
    */

}